const mergeDefaults = <T extends Record<string, unknown>>(
  defaultObj: T,
  targetObj: Partial<T>
): T => {
  const result = { ...targetObj } as T;

  for (const key in defaultObj) {
    if (
      !Object.prototype.hasOwnProperty.call(result, key) ||
      result[key] === undefined
    ) {
      result[key] = defaultObj[key];
    }
  }

  return result;
};

export default mergeDefaults;
